
namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass()
    export class DatasetGrid extends SiteEntityGrid<DatasetRow, any> {
        protected getColumnsKey() { return 'Dashboards.Dataset'; }
        protected getDialogType() { return DatasetDialog; }
        protected getIdProperty() { return DatasetRow.idProperty; }
        protected getInsertPermission() { return DatasetRow.insertPermission; }
        protected getLocalTextPrefix() { return DatasetRow.localTextPrefix; }
        protected getService() { return DatasetService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}